import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

const colorStyles = {
  primary: {
    bg: "bg-primary/10",
    border: "border-primary/30",
    text: "text-primary",
    accent: "text-primary"
  },
  accent: {
    bg: "bg-accent/10",
    border: "border-accent/30",
    text: "text-accent",
    accent: "text-accent"
  },
  real: {
    bg: "bg-power-real/10",
    border: "border-power-real/30",
    text: "text-power-real",
    accent: "text-power-real"
  },
  reactive: {
    bg: "bg-power-reactive/10",
    border: "border-power-reactive/30",
    text: "text-power-reactive",
    accent: "text-power-reactive"
  },
  apparent: {
    bg: "bg-power-apparent/10",
    border: "border-power-apparent/30",
    text: "text-power-apparent",
    accent: "text-power-apparent"
  },
  muted: {
    bg: "bg-muted/30",
    border: "border-border",
    text: "text-foreground",
    accent: "text-muted-foreground"
  }
};

export const ResultCard = ({ label, value, unit, color = "primary", formula }) => {
  const [copied, setCopied] = useState(false);
  const styles = colorStyles[color] || colorStyles.primary;

  const handleCopy = async () => {
    const textToCopy = `${value} ${unit}`.trim();
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopied(true);
      toast.success("Copied to clipboard!", {
        description: textToCopy,
        duration: 2000
      });
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast.error("Failed to copy");
    }
  };

  return (
    <div 
      className={`result-card p-4 rounded-lg border ${styles.bg} ${styles.border} transition-all hover:shadow-md`}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 min-w-0">
          <p className="text-xs font-medium text-muted-foreground mb-1 truncate">
            {label}
          </p>
          <div className="flex items-baseline gap-2">
            <span className={`text-2xl font-bold font-mono ${styles.text}`}>
              {value}
            </span>
            {unit && (
              <span className="text-sm font-medium text-muted-foreground">
                {unit}
              </span>
            )}
          </div>
          {formula && (
            <p className="text-xs text-muted-foreground mt-1.5 font-mono opacity-70">
              {formula}
            </p>
          )}
        </div>
        
        <Button
          variant="ghost"
          size="icon"
          className={`h-8 w-8 shrink-0 ${copied ? 'text-success' : 'text-muted-foreground hover:text-foreground'}`}
          onClick={handleCopy}
        >
          {copied ? (
            <Check className="h-4 w-4" />
          ) : (
            <Copy className="h-4 w-4" />
          )}
        </Button>
      </div>
    </div>
  );
};
